import { Component, OnInit, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { SimpleSearch } from 'src/app/core/models/simple-search.model';
import { User } from '../models/user.model';
import { UserService } from '../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordModalComponent } from './change-password-modal.component';

@Component({
    selector: 'list-users',
    templateUrl: './list-users.component.html',
    standalone: false
})
export class ListUsersComponent implements OnInit {

    public users: User[];
    public isLoading: boolean = true;
    public isBusy: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private modalService: NgbModal) {
        this.users = [];
    }

    ngOnInit(): void {

        this.route.queryParamMap
            .subscribe(params => {

                let search = new SimpleSearch();
                this.isLoading = true;

                this.userService.listUsers(search)
                    .then(response => {
                        console.log('## Users ##', response);
                        this.users = response.users;
                        this.isLoading = false;
                    }).catch(error => {
                    });
            });

    }

    createUser() {
        this.router.navigate(['/createUser']);
    }

    deleteUser(user: User) {
        console.log(user);

        if (!confirm(`Do you want to delete user ${user.email}?`)) {
            return;
        }

        this.isBusy = true;

        this.userService.deleteUser(user.email).then(() => {
            user.isDeleted = true;
        }, (error) => {
            console.log(error);
            alert('Something went wrong.');
        }).finally(() => {
            this.isBusy = false;

        });
    }

    makeAdmin(user: User) {
        console.log(user);

        if (!confirm(`Do you want to make user ${user.email} an admin for this app?`)) {
            return;
        }

        this.isBusy = true;

        this.userService.makeAdmin(user.email).then(() => {
            user.isAdmin = true;
            alert('Done');
        }, (error) => {
            console.log(error);
            alert('Something went wrong.');
        }).finally(() => {
            this.isBusy = false;
        });
    }

    // Replace the modal methods with this single method:
    openChangePasswordModal(user: User) {

        const modalRef = this.modalService.open(ChangePasswordModalComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'custom-modal',
            backdropClass: 'custom-backdrop',
            container: 'body'  // This can sometimes help with z-index issues
        });

        modalRef.componentInstance.user = user; 
    
        modalRef.result.then((result) => {
            // User clicked save
            this.isBusy = true;

            this.userService.changePassword(result.email, result.newPassword)
                .then(() => {
                    alert(`Password changed successfully for ${result.email}`);
                })
                .catch((error) => {
                    console.error('Error changing password:', error);

                    if (error.error && error.error.message) {
                        alert(`Error: ${error.error.message}`);
                    } else if (error.error && error.error.errors && Array.isArray(error.error.errors)) {
                        alert(`Error: ${error.error.errors.join(', ')}`);
                    } else {
                        alert('Failed to change password. Please try again.');
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }, (reason) => {
            // User clicked cancel or closed modal
            console.log('Modal dismissed');
        });
    }


}



